import { requestHttp } from '@/utils';

const EX_SERVER = ``;
// 方案管理API
const Scheme = {
  getScheme: `${EX_SERVER}/scheme/get`, // 查看单个方案
  getSchemeList: `${EX_SERVER}/scheme/list2`, // 查看方案列表
  addScheme: `${EX_SERVER}/scheme/add`, // 添加方案
  deleteScheme: `${EX_SERVER}/scheme/delete`, // 删除方案
  addSchemeExcel: `${EX_SERVER}/scheme_excel/add`, // 获取导出Excel地址
  updateSchemeDiscount: `${EX_SERVER}/scheme/discount/update` // 更新方案折扣
};
// 方案智能API
const SchemeRecomd = {
  getSchemeRecomd: `${EX_SERVER}/scheme_recomd/get`, // 获取智能推荐列表
  getAiSchemeRecomd: `${EX_SERVER}/scheme_recomd/ai/get`, // 大数据 获取智能推荐列表
  addSchemeRecomd: `${EX_SERVER}/scheme_recomd/add`, // 应用智能推荐列表
  getCartRecomd: `${EX_SERVER}/scheme_recomd/cart_cmd` // 应用智能推荐列表
};
// 方案清单管理API
const Schemeprod = {
  getSchemeprod: `${EX_SERVER}/scheme_prod/list`, // 查看方案的设备列表
  addSchemeprod: `${EX_SERVER}/scheme_prod/add`, // 添加方案的设备
  deleteSchemeprod: `${EX_SERVER}/scheme_prod/delete2`, // 删除方案的设备（新）
  updateSchemeprod: `${EX_SERVER}/scheme_prod/update`, // 更新方案的设备
  getSchemeprodTopo: `${EX_SERVER}/scheme_prod/topo/get`, // 查看方案的拓扑结构
  getDeviceImg: `${EX_SERVER}/scheme_prod/spu_pics/download` // 查看方案的拓扑结构
};
// 方案场景管理API
const Sence = {
  getSceneList: `${EX_SERVER}/scheme_scene/list`, // 查看方案场景列表
  getScene: `${EX_SERVER}/scheme_scene/get` // 查看方案场景
};
// 获取推荐商品
const Product = {
  getProdAttrList: `${EX_SERVER}/user_prod_attr/list`, // 查看商品类别关键属性
  getALLSubTree: `${EX_SERVER}/prod_category/all/subtree`, //  查看全部分类下的子树
  prodCategorySubtree: `${EX_SERVER}/prod_category/subtree2`, // 查看分类下的子树
  prodspuHavePriceAuth: `${EX_SERVER}/prod_spu/have_price_auth` // 查询查看成本价权限
};
// 方案的区域
const Region = {
  schemeRegionAdd: `${EX_SERVER}/scheme_region/add`, // 添加方案的区域
  schemeRegionAddList: `${EX_SERVER}/scheme_region/add_list`, // 添加方案的区域
  schemeRegionDelete: `${EX_SERVER}/scheme_region/delete`, // 删除方案的区域
  schemeRegionDeleteList: `${EX_SERVER}/scheme_region/delete_list`, // 删除方案的区域
  schemeRegionUpdate: `${EX_SERVER}/scheme_region/update`, // 更新方案的区域
  schemeRegionList: `${EX_SERVER}/scheme_region/list`, // 查询方案的区域列表
  sceneRegionList: `${EX_SERVER}/scheme_region/scene_region_list` // 查询场景的区域列表
};
// 购物车接口
const Cart = {
  getCartProdList: `${EX_SERVER}/cart_prod/list`, // 查看购物车设备
  addCartProd: `${EX_SERVER}/cart_prod/add`, // 添加商品到购物车
  deleteCartProd: `${EX_SERVER}/cart_prod/delete`, // 删除购物车设备
  emptyCartProd: `${EX_SERVER}/cart_prod/empty`, // 清空购物车设备
  updateCartProd: `${EX_SERVER}/cart_prod/update`, // 更新购物车设备
  cartToScheme: `${EX_SERVER}/cart_prod/to_scheme` // 购物车商品转化为清单
};
// 属性管理
const ProdAttr = {
  getAttrsByTags: `${EX_SERVER}/prod_attribute/by_tags/list` // 查看多个属性
};
// 商品管理对外开放API
const OpenProdSpu = {
  getProductInfoByName: `${EX_SERVER}/open_prod_spu/prods_name/list` // 根据产品名称批量查询
};

export const getScheme = (data = {}) => {
  return requestHttp({
    api: Scheme.getScheme,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const getSchemeList = (data = {}) => {
  return requestHttp({
    api: Scheme.getSchemeList,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const addScheme = (data = {}) => {
  return requestHttp({
    api: Scheme.addScheme,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const addSchemeExcel = (data = {}) => {
  return requestHttp({
    api: Scheme.addSchemeExcel,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const updateSchemeDiscount = (data = {}) => {
  return requestHttp({
    api: Scheme.updateSchemeDiscount,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const deleteScheme = (data = {}) => {
  return requestHttp({
    api: Scheme.deleteScheme,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const getSchemeprod = (data = {}) => {
  return requestHttp({
    api: Schemeprod.getSchemeprod,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const addSchemeprod = (data = {}) => {
  return requestHttp({
    api: Schemeprod.addSchemeprod,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const deleteSchemeprod = (data = {}) => {
  return requestHttp({
    api: Schemeprod.deleteSchemeprod,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const updateSchemeprod = (data = {}) => {
  return requestHttp({
    api: Schemeprod.updateSchemeprod,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const getSchemeprodTopo = (data = {}) => {
  return requestHttp({
    api: Schemeprod.getSchemeprodTopo,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const getDeviceImg = id => {
  return `${Schemeprod.getDeviceImg}/${id}`;
};

export const getSceneList = (data = {}) => {
  return requestHttp({
    api: Sence.getSceneList,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const getScene = (data = {}) => {
  return requestHttp({
    api: Sence.getScene,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const getProdAttrList = (data = {}) => {
  return requestHttp({
    api: Product.getProdAttrList,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const getSchemeRecomd = (data = {}) => {
  return requestHttp({
    api: SchemeRecomd.getSchemeRecomd,
    method: 'GET',
    module: 'mall',
    querys: data || {}
  });
};

export const getCartRecomd = (data = {}) => {
  return requestHttp({
    api: SchemeRecomd.getCartRecomd,
    method: 'GET',
    module: 'mall',
    querys: data || {}
  });
};

export const getAiSchemeRecomd = (data = {}) => {
  return requestHttp({
    api: SchemeRecomd.getAiSchemeRecomd,
    method: 'GET',
    module: 'mall',
    querys: data || {}
  });
};

export const addSchemeRecomd = (data = {}) => {
  return requestHttp({
    api: SchemeRecomd.addSchemeRecomd,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

// 方案的区域接口
export const schemeRegionAdd = (data = {}) => {
  return requestHttp({
    api: Region.schemeRegionAdd,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const schemeRegionAddList = (data = {}) => {
  return requestHttp({
    api: Region.schemeRegionAddList,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const schemeRegionUpdate = (data = {}) => {
  return requestHttp({
    api: Region.schemeRegionUpdate,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const schemeRegionDelete = (data = {}) => {
  return requestHttp({
    api: Region.schemeRegionDelete,
    method: 'POST',
    module: 'mall',
    querys: data
  });
};

export const schemeRegionDeleteList = (data = {}) => {
  return requestHttp({
    api: Region.schemeRegionDeleteList,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const schemeRegionList = (data = {}) => {
  return requestHttp({
    api: Region.schemeRegionList,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const sceneRegionList = (data = {}) => {
  return requestHttp({
    api: Region.sceneRegionList,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const getCartProdList = (data = {}) => {
  return requestHttp({
    api: Cart.getCartProdList,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const addCartProd = (data = {}) => {
  return requestHttp({
    api: Cart.addCartProd,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const deleteCartProd = (data = {}) => {
  return requestHttp({
    api: Cart.deleteCartProd,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const emptyCartProd = (data = {}) => {
  return requestHttp({
    api: Cart.emptyCartProd,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const updateCartProd = (data = {}) => {
  return requestHttp({
    api: Cart.updateCartProd,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const cartToScheme = (data = {}) => {
  return requestHttp({
    api: Cart.cartToScheme,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

const SchemeChar = {
  getSceneCharList: `${EX_SERVER}/scheme_char/scene_char/list`, // 查看场景可选方案特色
  getSchemeCharList: `${EX_SERVER}/scheme_char/menu_char/list`, // 查看清单方案特色
  deleteSchemeCharList: `${EX_SERVER}/scheme_char/menu_char/delete`, // 删除清单方案特色
  addSchemeCharList: `${EX_SERVER}/scheme_char/menu_char/add`, // 添加清单方案特色
  updateSchemeCharList: `${EX_SERVER}/scheme_char/menu_char/update` // 添加清单方案特色
};

export const getSceneCharList = (data = {}) => {
  return requestHttp({
    api: SchemeChar.getSceneCharList,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const getSchemeCharList = (data = {}) => {
  return requestHttp({
    api: SchemeChar.getSchemeCharList,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const deleteSchemeCharList = (data = {}) => {
  return requestHttp({
    api: SchemeChar.deleteSchemeCharList,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const addSchemeCharList = (data = {}) => {
  return requestHttp({
    api: SchemeChar.addSchemeCharList,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const updateSchemeCharList = (data = {}) => {
  return requestHttp({
    api: SchemeChar.updateSchemeCharList,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const prodCategorySubtree = (data = {}) => {
  return requestHttp({
    api: Product.prodCategorySubtree,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const prodspuHavePriceAuth = (data = {}) => {
  return requestHttp({
    api: Product.prodspuHavePriceAuth,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

// 私有产品库管理API
const ProdUserSpu = {
  addProdUserSpu: `${EX_SERVER}/prod_user_spu/add`, // 添加商品
  getProdUserSpuOne: `${EX_SERVER}/prod_user_spu/get`, // 获取商品
  deleteProdUserSpu: `${EX_SERVER}/prod_user_spu/delete`, // 删除商品
  batchDeleteProdUserSpu: `${EX_SERVER}/prod_user_spu/batch/delete`, // 批量商品
  batchSetShare: `${EX_SERVER}/prod_user_spu/batch/set_share`, // 批量设置共享
  prodSetShare: `${EX_SERVER}/prod_user_spu/set_share`, // 设置共享
  updateProdUserSpu: `${EX_SERVER}/prod_user_spu/update`, // 更新商品
  getProdUserSpu: `${EX_SERVER}/prod_user_spu/list`, // 查看商品列表
  exportProdUserSpu: `${EX_SERVER}/prod_user_spu/export_prods`, // 导入私有产品库
  importProdUserSpu: `${EX_SERVER}/prod_user_spu/import_prods` // 导入私有产品库
};
// 私有产品库分类管理API
const ProdUserCategory = {
  addProdUserCategory: `${EX_SERVER}/prod_user_category/add`, // 添加分类
  getProdUserCategorys: `${EX_SERVER}/prod_user_category/list`, // 获取分类
  deleteProdUserCategory: `${EX_SERVER}/prod_user_category/delete`, // 删除分类
  updateProdUserCategory: `${EX_SERVER}/prod_user_category/update` // 更新分类
};

export const addProdUserSpu = (data = {}) => {
  return requestHttp({
    api: ProdUserSpu.addProdUserSpu,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const deleteProdUserSpu = (data = {}) => {
  return requestHttp({
    api: ProdUserSpu.deleteProdUserSpu,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const batchDeleteProdUserSpu = (data = {}) => {
  return requestHttp({
    api: ProdUserSpu.batchDeleteProdUserSpu,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const batchSetShare = (data = {}) => {
  return requestHttp({
    api: ProdUserSpu.batchSetShare,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const prodSetShare = (data = {}) => {
  return requestHttp({
    api: ProdUserSpu.prodSetShare,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const updateProdUserSpu = (data = {}) => {
  return requestHttp({
    api: ProdUserSpu.updateProdUserSpu,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const getProdUserSpuOne = (data = {}) => {
  return requestHttp({
    api: ProdUserSpu.getProdUserSpuOne,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const getProdUserSpu = (data = {}) => {
  return requestHttp({
    api: ProdUserSpu.getProdUserSpu,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const importProdUserSpu = (data = {}) => {
  return requestHttp({
    api: ProdUserSpu.importProdUserSpu,
    headers: {
      'Content-type': 'multipart/form-data'
    },
    method: 'POST',
    module: 'mall',
    timeout: 30000,
    backErrorCode: true,
    querys: data.query || {},
    params: data.body || {}
  });
};

export const exportProdUserSpu = (data = {}) => {
  return requestHttp({
    api: ProdUserSpu.exportProdUserSpu,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const addProdUserCategory = (data = {}) => {
  return requestHttp({
    api: ProdUserCategory.addProdUserCategory,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};
export const getProdUserCategorys = (data = {}) => {
  return requestHttp({
    api: ProdUserCategory.getProdUserCategorys,
    method: 'POST',
    module: 'mall',
    backErrorCode: true,
    querys: data.query || {},
    params: data.body || {}
  });
};
export const deleteProdUserCategory = (data = {}) => {
  return requestHttp({
    api: ProdUserCategory.deleteProdUserCategory,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};
export const updateProdUserCategory = (data = {}) => {
  return requestHttp({
    api: ProdUserCategory.updateProdUserCategory,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

// 案例库管理
const SchemeCase = {
  addSchemeCase: `${EX_SERVER}/scheme_case/add`, // 添加案例
  getSchemeCaseList: `${EX_SERVER}/scheme_case/list`, // 查看制作案例列表
  getSchemeCasePublishList: `${EX_SERVER}/scheme_case/publish_list`, // 查看案例列表已发布
  schemeCaseToMyScheme: `${EX_SERVER}/scheme_case/to_my_scheme`, // 将案例设置为清单
  updateSchemeCase: `${EX_SERVER}/scheme_case/update`, // 更新案例
  updateSchemeCaseStatus: `${EX_SERVER}/scheme_case/update_status` // 添加案例
};

export const addSchemeCase = (data = {}) => {
  return requestHttp({
    api: SchemeCase.addSchemeCase,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const getSchemeCaseList = (data = {}) => {
  return requestHttp({
    api: SchemeCase.getSchemeCaseList,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const updateSchemeCase = (data = {}) => {
  return requestHttp({
    api: SchemeCase.updateSchemeCase,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const updateSchemeCaseStatus = (data = {}) => {
  return requestHttp({
    api: SchemeCase.updateSchemeCaseStatus,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

// 厂商案例
const SchemeUserCase = {
  getSchemeCasePublishList: `${EX_SERVER}/scheme_user_case/publish_list`, // 查看案例列表已发布
  schemeCaseToMyScheme: `${EX_SERVER}/scheme_user_case/to_my_scheme` // 将案例设置为清单
};

export const getSchemeCasePublishList = (data = {}) => {
  return requestHttp({
    api: SchemeUserCase.getSchemeCasePublishList,
    method: 'GET',
    module: 'mall',
    querys: data
  });
};

export const schemeCaseToMyScheme = (data = {}) => {
  return requestHttp({
    api: SchemeUserCase.schemeCaseToMyScheme,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const getProductInfoByName = (data = {}) => {
  return requestHttp({
    api: OpenProdSpu.getProductInfoByName,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const getAttrsByTags = (data = {}) => {
  return requestHttp({
    api: ProdAttr.getAttrsByTags,
    method: 'POST',
    module: 'mall',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const getALLSubTree = ({ data = {}, params = {} }) => {
  return requestHttp({
    method: 'GET',
    module: 'mall',
    api: Product.getALLSubTree,
    params,
    data
  });
};
